import React, { useState } from 'react';

const FinancialSitn = ({ onNext, answers, stepKey }) => {
  const [error, setError] = useState('');
  const [description, setDescription] = useState(answers[stepKey] || '');

  const handleContinue = () => {
    if (description.trim() === '' || description.length < 3) {
      setError('Please provide a description (at least 3 characters).');
    } else {
      setError('');
      onNext(description);
    }
  };

  const handleChange = (e) => {
    setDescription(e.target.value);
    if (error) {
      setError('');
    }
  };

  return (
    <>
      <div className="qs-card__head">
        <h2 className="qs-card__title">
          Please describe how this affected your financial situation
        </h2>
      </div>
      <div className="qs-card__body">
        <textarea
          name="financialSituation"
          className="qs-textarea"
          placeholder="Explain here"
          value={description}
          onChange={handleChange}
        />

        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

        <div className="qs-actions">
          <button
            type="button"
            className="qs-btn qs-btn--primary js-next"
            onClick={handleContinue}
          >
            Continue <span className="qs-arrow">→</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default FinancialSitn;
